import React, { forwardRef } from "react";
import { Link, type LinkProps } from "react-router-dom";
import {
  buttonStyles,
  type ButtonSize,
  type ButtonVariant,
} from "./buttonStyles";

export type LinkButtonVariant = ButtonVariant;

export interface LinkButtonProps extends LinkProps {
  variant?: LinkButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
}

const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  function LinkButton(
    {
      variant = "secondary",
      size = "sm",
      fullWidth = false,
      leadingIcon,
      trailingIcon,
      className = "",
      children,
      ...props
    },
    ref,
  ) {
    return (
      <Link
        ref={ref}
        className={buttonStyles({ variant, size, fullWidth, className })}
        {...props}
      >
        {leadingIcon}
        {children}
        {trailingIcon}
      </Link>
    );
  },
);

export default LinkButton;
